<script>

import {onMount} from "svelte";





</script>


<div class="dataAnalysisContainer">


<iframe class="dataIframe" src="https://peto981.shinyapps.io/ExcelDataViewer/"/>
	
</div>



<style>

.dataAnalysisContainer{
	height: 100%;
	width: -webkit-fill-available;
}

.dataIframe{
	overflow: auto;
	height: 100%;
	width: -webkit-fill-available;
	border-width: 0px;
}

</style>